import { Model } from "backbone"
/* eslint-disable
    no-multi-assign,
    no-return-assign,
    no-shadow,
    no-unused-vars,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
let Comments
export default Comments = class Comments extends Model {
  url() {
    if (this.user.isEditor()) {
      return `/content/${this.content_id}/comments/for-editor`
    } else {
      return `/content/${this.content_id}/comments`
    }
  }

  initialize(options) {
    this.content_id = options.content_id
    this.user = options.user
  }
}
